<section class="hero" [ngClass]="{'hero--full-header': logoURL !== ''}">
    <div class="container hero__container">
        <h1 class="hero__headline">
            <span class="hero__pretitle">{{ preTitle }}</span>
            <span class="hero__title" *ngIf="title">{{ title }}</span>
            <span class="hero__subtitle" *ngIf="subtitle">{{ subtitle }}</span>
        </h1>
        <button [disabled]="ctaDisabled" (click)="register()" class="button button--primary hero__button">{{ ctaButtonText }}</button>
        <p *ngIf="appointmentsAvailable" class="hero__text">
            {{ ctaAppointmentText }}
            <a class="hero__link" href="#">{{ ctaAppointmentButtonText }}</a>
        </p>
    </div>
</section>